var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_profile_ic",
    transform: "translate(-112 -97.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_11500",
    "data-name": "Path 11500",
    transform: "translate(112 97.995)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H30a2,2,0,0,1,2,2V30a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 0.5 C 1.17289924621582 0.5 0.5 1.17289924621582 0.5 2 L 0.5 30 C 0.5 30.82710075378418 1.17289924621582 31.5 2 31.5 L 30 31.5 C 30.82710075378418 31.5 31.5 30.82710075378418 31.5 30 L 31.5 2 C 31.5 1.17289924621582 30.82710075378418 0.5 30 0.5 L 2 0.5 M 2 0 L 30 0 C 31.10457038879395 0 32 0.8954296112060547 32 2 L 32 30 C 32 31.10457038879395 31.10457038879395 32 30 32 L 2 32 C 0.8954296112060547 32 0 31.10457038879395 0 30 L 0 2 C 0 0.8954296112060547 0.8954296112060547 0 2 0 Z",
    stroke: "none",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    d: "M36.036,19.144A3.633,3.633,0,1,1,32.4,22.777,3.633,3.633,0,0,1,36.036,19.144Zm0,15.809a8.06,8.06,0,0,1-5.249-1.935,1.548,1.548,0,0,1-.543-1.177,3.663,3.663,0,0,1,3.681-3.662h4.227a3.658,3.658,0,0,1,3.675,3.662,1.545,1.545,0,0,1-.543,1.177A8.057,8.057,0,0,1,36.034,34.954Z",
    transform: "translate(91.963 87.249)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerProfile);
export default __webpack_public_path__ + "static/media/customer_Profile.8879a5d1.svg";
export { ForwardRef as ReactComponent };